export default __webpack_public_path__ + "static/media/bedroom6.f5908214.webp";